/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useLotStore = defineStore("lot", {
  actions: {
    async lotListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          lotNumber: payload.lotNumber,
          status: payload.status, // ACTIVE, COMPLETE
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async returnValueListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          lotUid: payload.lotUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/return/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async lotAddFetch(payload) {
      const body = {
        list: payload.list,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async addReturnValueFetch(payload) {
      const body = {
        lotUid: payload.lotUid,
        amount: payload.amount,
        catUid: payload.catUid,
        catName: payload.catName,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/return/add";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async completeLotFetch(payload) {
      const body = {
        uid: payload.uid, // lot uid
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/complete";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async updateReturnValueFetch(payload) {
      const body = {
        uid: payload.uid,
        catUid: payload.catUid,
        catName: payload.catName,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/return/update";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async listAllowCatFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl =
            "/pawn-svc/breaking/lot/return/allow/cat/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
